var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.031,
    height: 183.34,
    viewBox: "0 0 141.031 183.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(-0.109)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M.109,59.957V218.852a3.061,3.061,0,0,0,3.066,3.056h116.5a3.061,3.061,0,0,0,3.065-3.056V90.515c0-.068-.033-.126-.039-.193a2.873,2.873,0,0,0-.157-.785c-.034-.1-.058-.193-.1-.288a3.024,3.024,0,0,0-.614-.895L91.175,57.8a2.974,2.974,0,0,0-.9-.612,2.773,2.773,0,0,0-.282-.1,3.048,3.048,0,0,0-.794-.159c-.052.009-.112-.024-.177-.024H3.176A3.06,3.06,0,0,0,.109,59.957Zm112.168,27.5H92.086V67.334ZM6.241,63.013H85.955v27.5a3.06,3.06,0,0,0,3.065,3.055h27.593V215.8H6.241Zm0,0",
    transform: "translate(0 -38.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M167.38,158.895v6.111h9.2a3.06,3.06,0,0,0,3.066-3.055V3.056A3.061,3.061,0,0,0,176.578,0H60.074a3.061,3.061,0,0,0-3.066,3.056v9.167H63.14V6.111H173.511V158.895Zm0,0",
    transform: "translate(-38.504 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M75.977,189.668h73.58v6.111H75.977Zm0,0",
    transform: "translate(-51.34 -128.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M75.977,132.766H100.5v6.112H75.977Zm0,0",
    transform: "translate(-51.34 -89.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M75.977,246.566h49.054v6.112H75.977Zm0,0",
    transform: "translate(-51.34 -167.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M246.676,246.566h18.395v6.112H246.676Zm0,0",
    transform: "translate(-166.854 -167.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M75.977,303.465h73.58v6.112H75.977Zm0,0",
    transform: "translate(-51.34 -205.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M75.977,417.266h73.58v6.112H75.977Zm0,0",
    transform: "translate(-51.34 -282.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M161.324,360.367h45.988v6.111H161.324Zm0,0",
    transform: "translate(-109.095 -244.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M75.977,360.367H97.438v6.111H75.977Zm0,0",
    transform: "translate(-51.34 -244.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M75.977,474.168H88.24v6.111H75.977Zm0,0",
    transform: "translate(-51.34 -321.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M132.875,474.168h55.186v6.111H132.875Zm0,0",
    transform: "translate(-89.844 -321.384)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPlaceholder);
export default __webpack_public_path__ + "static/media/document_placeholder.4716d4f109a59b6034db7bca02bfcb37.svg";
export { ForwardRef as ReactComponent };